import { useEffect, useState } from "react";
import Fibonacci from "../images/explore/fibonacci.png";
import FuturisticCity from "../images/explore/futuristic-city.png";
import IslandGhibli from "../images/explore/island-ghibli.png";
import IsometricColumns from "../images/explore/isometric-columns.png";
import LadyAndFlowers from "../images/explore/lady-and-flowers.png";
import Mermaid from "../images/explore/mermaid.png";
import NightDrive from "../images/explore/night-drive.png";
import RadioactiveCat from "../images/explore/radioactive-green-cat.png";
import Skynet from "../images/explore/skynet.png";
import Turtles from "../images/explore/turtles.png";
import VibrantWoman from "../images/explore/vibrant-woman.png";
import WatercolorBright from "../images/explore/watercolor-bright.png";
import { getPublicGalleries } from "../api-helper";
import PromptSpin from "../images/prompts.lottie";
import { db } from "../db";
import { useGenerateStatus } from "../context/GenerateContext";
import Logo from "../images/logo_light_grey.png";
import electronBridge from "../utils/electronBridge";
import Masonry from 'react-masonry-css';
import { getResponsiveMasonryBreakpoints } from "../utils/responsive";


const imageArray = [
    {
        src: Fibonacci,
        prompt: "Fibonacci, stone, snail, wallpaper, colorful, blue gray green, 3d pattern"
    },{
        src: FuturisticCity,
        prompt: "A futuristic city on a distant planet with purple sun on a cloudy day, light streaking through the clouds. Ultra realistic"
    },{
        src: IslandGhibli,
        prompt: "A beautiful scene of an island in the ocean studio ghibli"
    },{
        src: IsometricColumns,
        prompt: "Isometric Atlantis city,great architecture with columns, great details, ornaments,seaweed, blue ambiance, 3D cartoon style, soft light, 45° view"
    },{
        src: LadyAndFlowers,
        prompt: "Very female, in the style of steampunk over by plants, fantasy, with flowers, hyperrealism, sophisticated, vibrant surrealism art"
    },{
        src: Mermaid,
        prompt: "Mermaid looking up from the bottom of the ocean at the water surface from below the seaweed, dark lighting, finely detailed background, highly detailed face, Anna Dittmann, Zack Snyder"
    },{
        src: NightDrive,
        prompt: "Night drive starlight forest"
    },{
        src: RadioactiveCat,
        prompt: "A green cat with radioactive glow in its eyes in the style of an etch"
    },{
        src: Skynet,
        prompt: "The day after skynet took over sci-fi ultra realistic post apocalyptic"
    },{
        src: Turtles,
        prompt: "Arcane style flying turtle in a steampunk universe with stars and moons"
    },{
        src: VibrantWoman,
        prompt: "A vibrant professional studio portrait photography of a young, pale, goth, attractive, piercing green eyes, wears a gold ankh necklace, photoshopped"
    },{
        src: WatercolorBright,
        prompt: "A bright watercolor painting of a hazy morning with orange clouds reflecting on water"
    },
]

export default function Explore() {
    const generateStatus = useGenerateStatus();
    const [galleries, setGalleries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [animations, setAnimations] = useState(false);


    useEffect(() => {
        setLoading(true);
        getPublicGalleries().then(pubGalleries => {
            console.log(pubGalleries);
            let publicGalleries = pubGalleries.publicGalleries;
            setGalleries(publicGalleries)    
            setLoading(false);    
        })
    },[])

    useEffect(() => {
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting.value)
        })
    }, [generateStatus.loading])

    const openPublicGallery = (galleryName) => {
        if (electronBridge.isElectron) {
            electronBridge.ipcRenderer.send('open-urlInExternal', `https://${galleryName}.promptus.ai`)
        } else {
            window.open(`https://${galleryName}.promptus.ai`, "_blank");
        }
    }

    return (
        <div className={"px-4 relative container mx-auto"}>
            <h2 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                <span>Community Creations</span>
                <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"} />
            </h2>
            <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-full mx-auto"}>
                {loading ? 
                    <>
                        {animations ?
                            <div className="w-2/3 mx-auto">
                                <lottie-player
                                autoplay
                                loop
                                mode="normal"
                                src={PromptSpin}
                                ></lottie-player>
                            </div>
                        :
                            <img src={Logo} alt={"Promptus Logo"} className="w-2/3 mx-auto animate-pulse" />  
                        }
                    </>             
                :
                <Masonry
                    breakpointCols={getResponsiveMasonryBreakpoints()}
                    className="masonry-grid p-4 [contain:content]"
                    columnClassName="masonry-grid_column"
                >

                        {galleries.map((gallery) => (
                            <div className={"group w-full rounded-xl overflow-hidden relative border border-white"}>
                                <img className={"w-full"} src={gallery.image} alt={"Profile Picture"} />
                                <div className={"absolute bg-transparent top-0 left-0 w-full h-full flex-col place-items-center justify-center hidden group-hover:flex group-hover:bg-dark-blue/50 transition"}>
                                    <p className={"p-4 text-center"}>{gallery.name}</p>
                                    <button className="rounded w-1/2 mx-auto p-2 bg-yellow text-center text-dark-blue shadow font-bold text-sm"
                                    onClick={() => openPublicGallery(gallery.name)}>View Public Gallery</button>
                                </div>
                            </div>
                        ))}
                    {/* <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 overflow-auto max-h-screen`}> */}
                        {/* {imageArray.map(image => (
                            <div className={"group w-full rounded-xl overflow-hidden relative"}>
                                <img className={"w-full"} src={image.src} alt={image.prompt} />
                                <div className={"absolute bg-transparent top-0 left-0 w-full h-full flex-col place-items-center justify-center hidden group-hover:flex group-hover:bg-dark-blue/50 transition"}>
                                    <p className={"p-4 text-center"}>{image.prompt}</p>
                                </div>
                            </div>
                        ))} */}
                    {/* </div> */}
                    </Masonry>
                }
                
            </div>
        </div>
    );
}
